// types
import { ButtonProps, ButtonSize, ButtonType } from './types';

// styles
import './button.css';

// @TODO: replace `icon` and `text` properties by `label` propery which accepts anything
export default function Button({
  className,
  text = '',
  size = ButtonSize.MEDIUM,
  disabled,
  icon,
  type = ButtonType.BUTTON,
  onClick,
  bold,
  onMouseEnter,
  tabIndex,
  iconPosition = 'left',
}: ButtonProps): React.JSX.Element {
  return (
    <button
      type={type === 'button' ? 'button' : 'submit'}
      className={`button button-${size} ${className || ''} ${
        bold ? 'button-bold' : ''
      }`}
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      tabIndex={tabIndex}
    >
      {Boolean(icon) && iconPosition === 'left' && (
        <span className={`icon-wrapper ${!text ? 'no-spaces' : ''}`}>
          {icon}
        </span>
      )}
      {Boolean(text) && (
        <span className={`text ${icon ? 'with-icon' : ''}`}>{text}</span>
      )}
      {Boolean(icon) && iconPosition === 'right' && (
        <span
          className={`icon-wrapper icon-wrapper-right ${
            !text ? 'no-spaces' : ''
          }`}
        >
          {icon}
        </span>
      )}
    </button>
  );
}
